// Central Calendly config + helpers
export const CALENDLY_URL = "https://calendly.com/career-factors3709";

// Editorial theming for the embed
export const CALENDLY_PARAMS = {
  hide_gdpr_banner: 1,
  hide_landing_page_details: 0,
  primary_color: "C26D5C",
  text_color: "1A1C1A",
  background_color: "F4F2F0",
};

export function buildCalendlyUrl(base = CALENDLY_URL) {
  const q = new URLSearchParams(
    Object.fromEntries(Object.entries(CALENDLY_PARAMS).map(([k, v]) => [k, String(v)]))
  ).toString();
  return `${base}?${q}`;
}

export function openCalendlyPopup() {
  if (typeof window === "undefined") return;
  const url = buildCalendlyUrl();
  if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
    window.Calendly.initPopupWidget({ url });
  } else {
    // Fallback: open in new tab if script hasn't loaded yet
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
